/**
 * Bundle for all code need for ads.
 */
var adManager = require('./ad-manager/ad-manager.js');
var adEvents = require('./ad-manager/ad-events.js');
var gptInstaller = require('./gpt-installer/gpt-installer.js');
require('./ad-context/ad-context.js');
require('./ad-tags/async-gpt-tag.js');
require('./ad-unit-factory/ad-unit-factory.js');

// expose adManager to allow for refreshing/retargeting
module.exports = {
    install: function() {
        return gptInstaller.install();
    },
    adManager: adManager,
    adEvents: adEvents
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/index.js
// module id = 88
// module chunks = 36